import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { newGetBookings } from "../../../../../../actions/auth/booking";
import { useSelector, useDispatch } from "react-redux";
import BookingListFilter from "./BookingListFilter";
import SkeletonLoading from "./SkeletonLoading";
import MyPageBookingCard from "./MyPageBookingCard";

// Maps the newGetBookings type to the key it is stored under in the
// authBooking reducer (see reducers/authBooking.js).
const BOOKING_STORE_KEYS = {
  thisMonth: "authThisMonthBookings",
  current: "authCurrentBookings",
  upcoming: "authUpcomingBookings",
  previous: "authPreviousBookings",
  cancelled: "authCancelledBookings",
};

const BookingList = ({
  type,
  userRole,
  filterGetBookings: externalFilterGetBookings,
  changeFilter: externalChangeFilter,
  showFilter = true,
}) => {
  const { t } = useTranslation();
  const [filterGetBookings, setFilterGetBookings] = useState({
    search: "",
    orderBy: "pickupDateTime",
    sortBy: "asc",
  });

  const activeFilterGetBookings = externalFilterGetBookings || filterGetBookings;

  const { loading } = useSelector((state) => state.authBooking);
  const bookings = useSelector(
    (state) => state.authBooking[BOOKING_STORE_KEYS[type]]
  );
  const dispatch = useDispatch();

  // True while the debounced fetch below has not been dispatched yet, so the
  // skeleton shows immediately instead of flashing the empty state first.
  const [pendingFetch, setPendingFetch] = useState(true);

  useEffect(() => {
    setPendingFetch(true);

    const handler = setTimeout(() => {
      dispatch(newGetBookings({
        orderBy: activeFilterGetBookings.orderBy,
        sortBy: activeFilterGetBookings.sortBy,
        search: activeFilterGetBookings.search,
        page: 1,
        limit: 100,
      }, type));
      setPendingFetch(false);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [dispatch, activeFilterGetBookings, type]);

  const updateLocalFilter = (e) => {
    setFilterGetBookings({
      ...filterGetBookings,
      [e.target.name]: e.target.value,
    });
  };

  const handleChangeFilter = externalChangeFilter || updateLocalFilter;

  return (
    <>
      {showFilter && userRole === "business" && (
        <BookingListFilter
          changeFilter={handleChangeFilter}
          selectedCards={[]}
          filterGetBookings={activeFilterGetBookings}
        />
      )}

      {pendingFetch || loading ? (
        <SkeletonLoading />
      ) : bookings?.recordsFiltered > 0 ? (
        <div className="tw:my-4">
          {bookings?.data?.map((bookingDetail) => (
            <MyPageBookingCard
              key={bookingDetail._id}
              bookingDetail={bookingDetail}
            />
          ))}
        </div>
      ) : (
        <div className="tw:bg-white tw:border tw:border-[#E8E8E8] tw:flex tw:justify-center tw:items-center tw:py-[110px] tw:px-[26px] tw:mt-4 tw:mb-12 tw:rounded-[5px]">
          <p className="tw:m-0 tw:font-hanken-grotesk tw:text-[15px] tw:leading-[22px] tw:italic tw:text-[#8D8D8D] tw:text-center">{t('myPage.booking.bookingItem.noBooking')}</p>
        </div>
      )}
    </>
  );
};

export default BookingList;
